export const EVENT_SCREEN = {
  SIGN_READER: "autogram-sign-reader-screen",
  SIGN_MOBILE: "autogram-sign-mobile-screen",
};

export const EVENT_CLOSE = "autogram-close";

export const EVENT_SIGN = "autogram-sign";

export const EVENT_SHOW_QR_CODE = "autogram-show-qr-code";
